
// import React, { useState, useEffect } from "react";
// import {
//   Button,
//   Divider,
//   Grid,
//   TextField,
//   MenuItem,
//   Select,
//   InputLabel,
//   FormControl,
// } from "@mui/material";
// import patientService from "../../../Services/patientService";
// import toast from "react-hot-toast";
// import { useNavigate, useParams } from "react-router-dom";
// import doctorService from "../../../Services/doctorService";

// const AddEditDoctors = () => {
//   const [doctorData, setDoctorData] = useState({
//     name: "",
//     specialization: "",
//     phone_no: "",
//     cnic: "",
//     email: "",
//     qualification: "",
//     pay: 0,
//     experience: "",
//     commission: 0,
//     fee: 0,
//     status: 1
//   });

//   const { id } = useParams();
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setDoctorData({ ...doctorData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (id) {
//         await doctorService.update(id, doctorData);
//         toast.success("Doctor updated successfully!"); // Success message
//       } else {
//         await doctorService.create(doctorData);
//         toast.success("Doctor added successfully!"); // Success message
//       }
//       navigate("/doctor"); // Redirect after submission
//     } catch (error) {
//       toast.error("Error saving Doctor."); // Error message
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} className="w-[90%] m-auto">
//       <h1 className="m-[30px] text-center font-[700] text-[20px]">
//         {id ? "Edit Doctor" : "Add Doctor"}
//       </h1>
//       <Divider />
//       <div>
//         <div className="mt-[20px] flex">
//           <div style={{ width: "33%" }}>
//             <TextField
//               label="Doctor Name"
//               variant="outlined"
//               fullWidth
//               name="name"
//               value={doctorData.name}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "33%" }}>
//             <TextField
//               label="Phone No."
//               variant="outlined"
//               fullWidth
//               type="number"
//               name="phone_no"
//               value={doctorData.phone_no}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "33%" }}>            
//             <TextField
//               label="CNIC"
//               variant="outlined"
//               fullWidth
//               name="cnic"
//               value={doctorData.cnic}
//               onChange={handleChange}
//               required
//             />
//           </div>
//         </div>

//         <div className="mt-[20px] flex">
//           <div style={{ width: "50%" }}>
//             <TextField
//               label="Specialization"
//               variant="outlined"
//               fullWidth
//               name="specialization"
//               value={doctorData.specialization}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "50%" }}>
//             <TextField
//               label="Qualification"
//               variant="outlined"
//               fullWidth
//               name="qualification"
//               value={doctorData.qualification}
//               onChange={handleChange}
//               required
//             />
//           </div>
//         </div>

//         <div className="mt-[20px] flex">
//           <div style={{ width: "50%" }}>
//             <TextField
//               label="Email"
//               variant="outlined"
//               fullWidth
//               name="email"
//               value={doctorData.email}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "50%" }}>
//             <TextField
//               label="Pay"
//               variant="outlined"
//               fullWidth
//               type="number"
//               name="pay"
//               value={doctorData.pay}
//               onChange={handleChange}
//               required
//             />
//           </div>
//         </div>

//         <div className="mt-[20px] flex">
//           <div style={{ width: "33%" }}>
//             <TextField
//               label="Commission"
//               variant="outlined"
//               fullWidth
//               type="number"
//               name="commission"
//               value={doctorData.commission}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "33%" }}>
//             <TextField
//               label="Doctor Fee"
//               variant="outlined"
//               fullWidth
//               type="number"
//               name="fee"
//               value={doctorData.fee}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "33%" }}>
//             <TextField
//               label="Experience"
//               variant="outlined"
//               fullWidth
//               type="number"
//               name="experience"
//               value={doctorData.experience}
//               onChange={handleChange}
//               required
//             />
//           </div>
//         </div>

//         <Grid container style={{ justifyContent: "center", marginTop: "30px" }}>
//           <Button
//             variant="contained"
//             type="submit"
//             color="primary"
//             size="large"
//             className="!bg-gray-700 !text-white"
//             style={{ borderRadius: "10px" }}
//           >
//             Save and Continue
//           </Button>
//         </Grid>
//       </div>
//     </form>
//   );
// };

// export default AddEditDoctors;


import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import doctorService from "../../../Services/doctorService";

const SectionLabel = ({ children }) => (
  <p className="text-[11px] uppercase tracking-widest font-[500] text-gray-400 mb-3 mt-6">
    {children}
  </p>
);

const InputField = ({ label, ...props }) => (
  <div className="flex flex-col gap-1">
    <label className="text-[12px] font-[500] text-gray-500">{label}</label>
    <input
      {...props}
      className="w-full px-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg outline-none hover:border-orange-200 focus:border-orange-200 focus:ring-2 focus:ring-orange-100"
    />
  </div>
);

const ValidatedField = ({ label, value, maxLength, onChange, placeholder, hint }) => {
  const isComplete = value.length === maxLength;
  const isPartial = value.length > 0 && value.length < maxLength;

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center justify-between">
        <label className="text-[12px] font-[500] text-gray-500">{label}</label>
        {isPartial && (
          <span className="text-[11px] text-red-400">{maxLength - value.length} digits remaining</span>
        )}
        {isComplete && (
          <span className="text-[11px] text-green-500 font-[500]">✓ Valid {hint}</span>
        )}
      </div>
      <input
        type="text"
        value={value}
        onChange={onChange}
        required
        maxLength={maxLength}
        placeholder={placeholder}
        className={`w-full px-3 py-2 text-[13px] text-gray-800 bg-white border rounded-lg outline-none transition-colors
          hover:border-orange-200 focus:ring-2 focus:ring-orange-100
          ${isComplete
            ? "border-green-400 focus:border-green-400"
            : isPartial
            ? "border-red-300 focus:border-orange-200"
            : "border-gray-200 focus:border-orange-200"
          }`}
      />
    </div>
  );
};

const AddEditDoctors = () => {
  const [doctorData, setDoctorData] = useState({
    name: "",
    specialization: "",
    phone_no: "",
    cnic: "",
    email: "",
    qualification: "",
    pay: 0,
    experience: "",
    commission: 0,
    fee: 0,
    status: 1,
  });

  const { id } = useParams();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDoctorData({ ...doctorData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        await doctorService.update(id, doctorData);
        toast.success("Doctor updated successfully!");
      } else {
        await doctorService.create(doctorData);
        toast.success("Doctor added successfully!");
      }
      navigate("/doctor");
    } catch (error) {
      toast.error("Error saving Doctor.");
    }
  };

  return (
    <div className="bg-gray-50 flex items-start justify-center py-10 px-4">
      <div className="w-full max-w-7xl">
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">

          {/* Header */}
          <div className="bg-gray-800 px-8 py-5">
            <h1 className="text-white text-[18px] font-[500] tracking-tight">
              {id ? "Edit Doctor" : "New Doctor Registration"}
            </h1>
            <p className="text-gray-400 text-[12px] mt-0.5">
              {id ? "Update the doctor's details below" : "Fill in the details below to register a new doctor"}
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="px-8 py-6">

            <SectionLabel>Personal Information</SectionLabel>
            <div className="grid grid-cols-3 gap-4">
              <InputField
                label="Doctor Name"
                type="text"
                name="name"
                value={doctorData.name}
                onChange={handleChange}
                required
                placeholder="Enter full name"
              />
              <ValidatedField
                label="Phone Number"
                value={String(doctorData.phone_no)}
                maxLength={11}
                placeholder="e.g. 03001234567"
                hint="number"
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, "").slice(0, 11);
                  setDoctorData({ ...doctorData, phone_no: val });
                }}
              />
              <ValidatedField
                label="CNIC"
                value={String(doctorData.cnic)}
                maxLength={13}
                placeholder="13 digits, numbers only"
                hint="CNIC"
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, "").slice(0, 13);
                  setDoctorData({ ...doctorData, cnic: val });
                }}
              />
            </div>

            <div className="grid grid-cols-2 gap-4 mt-4">
              <InputField
                label="Specialization"
                type="text"
                name="specialization"
                value={doctorData.specialization}
                onChange={handleChange}
                required
                placeholder="Enter specialization"
              />
              <InputField
                label="Qualification"
                type="text"
                name="qualification"
                value={doctorData.qualification}
                onChange={handleChange}
                required
                placeholder="Enter qualification"
              />
            </div>

            <div className="grid grid-cols-2 gap-4 mt-4">
              <InputField
                label="Email"
                type="email"
                name="email"
                value={doctorData.email}
                onChange={handleChange}
                required
                placeholder="Enter email address"
              />
              <InputField
                label="Pay"
                type="number"
                name="pay"
                value={doctorData.pay}
                onChange={handleChange}
                required
                placeholder="Enter pay amount"
              />
            </div>

            <SectionLabel>Professional Details</SectionLabel>
            <div className="grid grid-cols-3 gap-4">
              <InputField
                label="Commission"
                type="number"
                name="commission"
                value={doctorData.commission}
                onChange={handleChange}
                required
                placeholder="Enter commission"
              />
              <InputField
                label="Doctor Fee"
                type="number"
                name="fee"
                value={doctorData.fee}
                onChange={handleChange}
                required
                placeholder="Enter consultation fee"
              />
              <InputField
                label="Experience (years)"
                type="number"
                name="experience"
                value={doctorData.experience}
                onChange={handleChange}
                required
                placeholder="Enter years of experience"
              />
            </div>

            {/* Footer */}
            <div className="border-t border-gray-100 mt-8 pt-6 flex items-center justify-between">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="text-[13px] text-gray-400 hover:text-gray-600 transition-colors font-[500]"
              >
                ← Cancel
              </button>
              <button
                type="submit"
                className="bg-gray-800 hover:bg-gray-700 transition-colors text-white text-[13px] font-[500] px-6 py-2.5 rounded-lg"
              >
                {id ? "Update Doctor" : "Save & Continue →"}
              </button>
            </div>

          </form>
        </div>

        <p className="text-center text-[12px] text-gray-400 mt-4">
          {id ? "Changes will be saved immediately." : "Doctor will be available for assignment after saving."}
        </p>
      </div>
    </div>
  );
};

export default AddEditDoctors;